import type { Notes } from '@octopus-do/octopus-project-core'
import type React from 'react'

import { SeoBlockOrPlaceholder } from '../SeoBlockOrPlaceholder'
import { SeoImage } from '../SeoImage'
import css from './styles.module.css'

interface Props {
  notes?: Notes
}

export const SeoBlockContainer: React.FC<Props> = ({ notes }) => (
  <div className={css.seo_block_container}>
    {notes?.seoImage && <SeoImage url={notes?.seoImage?.value} />}

    <SeoBlockOrPlaceholder
      value={notes?.seoTitle}
      placeholder="Title"
      type="title"
      hideDivider={!!notes?.seoDescription}
    />

    <SeoBlockOrPlaceholder
      value={notes?.seoDescription}
      placeholder="Description"
      type="description"
      hideDivider={!!notes?.seoSlug}
    />

    <SeoBlockOrPlaceholder
      value={notes?.seoSlug}
      placeholder="Slug"
      type="slug"
      hideDivider={!!notes?.keywords}
    />

    <SeoBlockOrPlaceholder
      value={notes?.keywords}
      placeholder="Keywords"
      type="keywords"
      hideDivider={!!notes?.pageIntent}
    />

    <SeoBlockOrPlaceholder
      value={notes?.pageIntent}
      placeholder="Page intent"
      type="page_intent"
      hideDivider
    />
  </div>
)
